import { Module } from '@nestjs/common';
import { PoCreationService } from './po-creation.service';
import { PoCreationController } from './po-creation.controller';
import { PoCreation } from './po-creation.entity';
import { PoItems } from './po-creation-items.entity';
import { TypeOrmModule } from '@nestjs/typeorm';
import { PurchaseOrderAdapter } from './dto/po-creation.adapter';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { FoodTypeService, ItemCategoryService, ItemsService, ItemSubCategoryService, PaymentTermsService, ProductService, SizesService, SkuService, TaxesService, TypeofValueAddition4Service, TypeofValueAddition5Service, UnitcodeService, UomsService, VendorsPriceListService, VendorsService } from '@gtpl/shared-services/masters';
import { PoRepository } from './repository/po-repository';
import { PoItemsAdapter } from './dto/po-creation-items.adapter';

import { PinoLogger } from 'nestjs-pino';
import { GrnService } from '@gtpl/shared-services/procurement';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { AuthModel } from '@gtpl/shared-models/common-models';
import { POAdapter } from './dto/purchaser-order.adapter';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { ScheduleModule } from '@nestjs/schedule';
import {  WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast'


@Module({
  imports: [
    TypeOrmModule.forFeature([PoCreation,PoRepository,PoItems]),
    ScheduleModule.forRoot()
  ],
  providers: [WhatsAppNotificationService,PoCreationService,PurchaseOrderAdapter,PoItemsAdapter,ApplicationExceptionHandler,VendorsService,ItemCategoryService,ItemsService,GrnService,SizesService, SaleOrderService, AuthModel, VendorsPriceListService, TaxesService, PaymentTermsService, POAdapter, ItemSubCategoryService, UnitcodeService ,FoodTypeService,ProductService,TypeofValueAddition4Service,TypeofValueAddition5Service,WhatsappBroadCastService,UomsService],
 
  controllers: [PoCreationController],
  exports:[PoCreationService]
})
export class PoCreationModule {}

